import { LineChartOutlined, MailOutlined, TeamOutlined, UnorderedListOutlined } from '@ant-design/icons'
import { TabBar } from 'antd-mobile'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'

const tabs = [
    { key: '/posts', title: 'Постинг', icon: <MailOutlined />, defaultLink: '/posts/scheduled' },
    { key: '/advertising', title: 'Рекламный постинг', icon: <TeamOutlined />, defaultLink: '/advertising/buy' },
    {
        key: '/internet-resources',
        title: 'Интернет ресурсы',
        icon: <UnorderedListOutlined />,
        defaultLink: '/internet-resources'
    },
    { key: '/statistics', title: 'Статистика', icon: <LineChartOutlined />, defaultLink: '/statistics' }
]

function findActiveKey(pathname: string) {
    const tab = tabs.find((t) => !!matchPath({ path: t.key + '/*', end: false }, pathname) || pathname === t.key)
    return tab ? tab.key : ''
}

export const BottomNavMobile = () => {
    const navigate = useNavigate()
    const { pathname, search } = useLocation()

    const activeKey = findActiveKey(pathname)

    return (
        <TabBar
            activeKey={activeKey}
            onChange={(value) => {
                const tab = tabs.find((t) => t.key === value)
                if (!tab) return
                navigate((tab.defaultLink ?? tab.key) + search)
            }}
            safeArea
        >
            {tabs.map((item) => (
                <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
            ))}
        </TabBar>
    )
}
